import { render } from "./ProductAddlist.vue?vue&type=template&id=6d94070c"
import script from "./ProductAddlist.vue?vue&type=script&lang=js"
export * from "./ProductAddlist.vue?vue&type=script&lang=js"

import "./ProductAddlist.vue?vue&type=style&index=0&id=6d94070c&lang=css"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__